import React from 'react';
import PropTypes from 'prop-types';

import ChangelogLink from '@appComponents/ChangelogLink';

import FormChangelogEntry from './FormChangelogEntry';

export const FormChangelog = ({data, resources, isForForm = false}) => {
    const formStyleClassName = isForForm ? 'changelog-data--formStyling' : '';

    return data ?
        (<div className={`changelogData ${formStyleClassName}`}>
            <FormChangelogEntry
                label='Created on'
                date={data.creation_datetime}
                user={data.creation_user}
            />
            <FormChangelogEntry
                label='Last update on'
                date={data.update_datetime}
                user={data.update_user}
            />
            <FormChangelogEntry
                label='Cancelled on'
                date={data.cancellation_datetime}
                user={data.cancellation_user}
            />
            {data.creation_datetime && <ChangelogLink resources={resources} elementId={data.id} />}
        </div>)
        : null;
};

FormChangelog.propTypes = {
    data: PropTypes.object,
    resources: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.number),
    ]),
    isForForm: PropTypes.bool,
};

export default FormChangelog;
